import { IGetState, TBoardId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { getAuthUser } from '../../../store/model/authUser/selectors/getAuthUser';
import { getBoard } from '../../../store/model/selectors/getBoardById';
import { toggleBoardStarred } from '../aside_panel/boardDetails/details/StarredButton/hocs/BoardStarredButtonHOC/effects/toggleBoardStarred';
import { ERecentAccordion } from '../../../types/rest/IUserMeta';
import { authUserSetRecentAccordion } from '../../../rest/effects/authUser/authUserSetRecentAccordion';

export const moveBoardIconToStarred = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const state = getState();
        const authUser = getAuthUser(state);
        const recentAccordion = authUser.meta && authUser.meta.recentAccordion;
        const board = getBoard(state, boardId);
        const isStarred = board && board.starred;
        if (isStarred) {
            const interval = setInterval(() => {
                const target = document.querySelector(`[data-rbd-draggable-id="${boardId}"]`) as HTMLElement;
                if (target) {
                    target.style.opacity = '0';
                    if (recentAccordion && recentAccordion === ERecentAccordion.STARRED) {
                        requestAnimationFrame(() => {
                            animation(boardId);
                        })
                    }
                    clearInterval(interval);
                }
            }, 0);
            if (recentAccordion && recentAccordion === ERecentAccordion.RECENT) {
                dispatch(authUserSetRecentAccordion(ERecentAccordion.STARRED)).then(() => {
                    requestAnimationFrame(() => {
                        animation(boardId, 200);
                    })
                    setTimeout(() => {
                        dispatch(authUserSetRecentAccordion(ERecentAccordion.RECENT))
                    }, 2000)
                })
            }
        }
    };
    return action;
}

const animation = (
    boardId: TBoardId,
    delay?: number
) => {
    const boardIcon = document.querySelector('.top-bar .navigation-panel__close_marker');
    const quickStartLogo = document.querySelector('.top-bar .topbar__logo');
    const cloneIcon = boardIcon ? boardIcon : quickStartLogo;
    const clone = cloneIcon.cloneNode(true) as HTMLElement;
    clone.classList.add('navigation-panel__icon-clone');
    const target = document.querySelector(`[data-rbd-draggable-id="${boardId}"]`) as HTMLElement;
    if (target) {
        target.style.opacity = '0';
        setTimeout(() => {
            const top = target.getBoundingClientRect().top;
            clone.style.setProperty('--top', `${top - 8}px`);//8px разница между размерами между изначальный и конечной иконкой по одной стороне
            const navPanel = document.querySelector('.navigation-panel')
            navPanel.appendChild(clone);
            setTimeout(()=> {
                clone.remove();
                target.style.opacity = '1';
            }, 600) //время анимации перемещения
        }, delay) //задержка перед срабатываем анимации
    }
}
